<div class="main-title">Works with</div>
@for (field of worksWithData; track $index) {
  <div class="sub-title">{{ field?.label }}</div>
  <div class="info">{{ field.defaultValue }}</div>
}
